<template>
  <div class="page">
    <h2 v-if="!this.isCompleted">Jouw woning wordt geanalyseerd...</h2>
    <h2 v-else>De analyse van jouw woning is voltooid.</h2>
    <progressbar class="progressbar" :steps="totalsteps" :step="progressstep" />
    <form class="page-form">
      <div class="form-row">
        <ul class="checklist">
          <li v-bind:class="{ 'active' : this.progressstep > 1 }">Adres verifi&#235;ren</li>
          <li v-bind:class="{ 'active' : this.progressstep > 2 }">Dakhelling controleren</li>
          <li v-bind:class="{ 'active' : this.progressstep > 3 }">Schaduw objecten in kaart brengen</li>
          <li v-bind:class="{ 'active' : this.progressstep > 4 }">Formaat dak bepalen</li>
        </ul>
      </div>
      <div class="form-row nav-buttons bottom">
        <button v-bind:class="{ enabled : isCompleted }" v-on:click="next()" type="button">Volgende</button>
      </div>
    </form>
  </div>
</template>

<script>
  import progressbarComponent from './../components/progressbarComponent.vue';
  import validation from './../plugins/validations.js';

  export default {
    name: 'analysePage',
    components: {
      'progressbar' : progressbarComponent
    },
    data : function(){
      return{
        totalsteps : 5,
        step : 1,
        progressstep : 1,
        timer: null
      }
    },
    mounted() {
      this.startAnalyzing()
    },
    destroyed() {
      try { clearInterval(this.timer) } catch (e) {}
    },
    computed: {
      isCompleted() {
        return this.$store.getters.is_completed_step(this.step) && (this.progressstep == this.totalsteps)
      },
    },
    methods : {
      next() {
        if( this.isCompleted == true ) {
          this.$router.push('/verbruik')
        }
      },
      startAnalyzing() {
        var _this = this
        this.timer = setInterval( _this.timerTick, 750)
      },
      timerTick() {
        this.progressstep++
        if( this.progressstep == 5 ) try { clearInterval(this.timer) } catch (e) {}
      }

    },
  }
</script>

<style scoped lang="scss">
  .progressbar {
    margin-top: 40px;
  }
  ul.checklist{
    margin: 0;
    padding: 0;

    > li{
      position: relative;
      line-height: 40px;
      font-size: 1.35rem;
      font-weight: bold;
      color: white;
      list-style: none;

      &:before{
        content: 'V';
        position: absolute;
        left: -30px;
        color: $color-yellow-dark;
      }

      &.active{
        color: $color-primary;
        transition: color 350ms;
        &:before{
          color: $color-primary;
          transition: color 350ms;
        }
      }
    }
  }
</style>

